export default __webpack_public_path__ + "static/banner-real-894d8d990d44b7f0080ba635f1105c49.webp";